<template>
  <div v-if="taskDefinition">
    <!-- Vue mount component but props is undefined -->
    <h1>{{ taskDefinition.name }}</h1>
    <JsonEditor :value="taskDefinition" @input="setTaskDefinition" />
    <button @click="updateTaskDefinition(taskDefinition)">Save</button>
    <button @click="cancelUpdateTaskDefinition(taskType)">Cancel</button>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import JsonEditor from '@/components/JsonEditor.vue'

export default {
  name: 'TaskDefinitionEdit',
  props: ['taskType'],
  computed: mapState(['taskDefinition']),
  methods: {
    ...mapActions([
      'getTaskDefinition',
      'updateTaskDefinition',
      'cancelUpdateTaskDefinition'
    ]),
    ...mapMutations(['setTaskDefinition'])
  },
  created() {
    this.getTaskDefinition(this.taskType)
  },
  watch: {
    taskType: function() {
      this.getTaskDefinition(this.taskType)
    }
  },
  components: {
    JsonEditor
  }
}
</script>
